<!--  This Component is a recursive tree (using a component recursively ) -->
<!-- It resolves data having title,val (val can be )  -->
<!-- This is used to track the activities and this manages the details in the form of recursive tree. Can be found in audit trail(UI) -->
<template>
  <tr v-if="node.val" class="px-0 py-0">
    <td class="py-1">{{ node.title }}</td>
    <td
      class="py-1"
      v-if="node.val && node.val.length && typeof node.val === 'object'"
    >
      <node v-for="child in node.val" :node="child" :key="child.id"></node>
    </td>
    <td class="py-1 wrap-text" width="60%" v-else>{{ node.val }}</td>
  </tr>
  <tr class="px-0 py-0" v-else-if="node.length">
    <node v-for="child in node" :node="child" :key="child.id"></node>
  </tr>
  <tr class="px-0 py-0" v-else>
    <td>{{ node.title }}</td>
    <td>{{ node.val }}</td>
  </tr>
</template>

<script>
/**
 * @node to contain title, value of the activity 
 */
import { removeHTMLTags } from '@/helpers/common';
export default {
  name: 'node',
  props: ['node'],

  mounted() {
    this.getUserName();
  },
  // everytime node changes, it calls getUserName()
  watch: {
    node: function() {
      this.getUserName();
    }
  },
  methods: {
    // this function is used to get the user name, assigns node.value accordingly 
    async getUserName() {
      if (typeof this.node.val === 'string') {
        this.node.val = removeHTMLTags(this.node.val);
      }
      if (
        typeof this.node.val === 'string' &&
        this.node.val.includes('_resolveEpoch')
      ) {
        const epoch = this.node.val.replace('_resolveEpoch', '');
        this.node.val = this.getFormatedDateAsPerTimeAndDate(
          parseInt(epoch, 10)
        );
        return;
      }
      if (
        typeof this.node.val === 'string' &&
        this.node.val.includes('_resolve')
      ) {
        const userId = this.node.val.replace('_resolve', '');
        await this.addUserDetails[userId];
        this.node.val = this.formatUserName(this.userIdNameMap[userId]);
      }
    }
  }
};
</script>
